export var breakpoints = function () {
    return {
        'breakpoints': {
            'desktop': window.matchMedia('(min-width: 1024px)').matches,
            'desktop_down': window.matchMedia('(max-width: 1023px)').matches,
            'desktop_small': window.matchMedia('(min-width: 1024px) and (max-width: 1300px)').matches,
            'tablet_up': window.matchMedia('(min-width: 768px)').matches,
            'tablet': window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches,
            'mobile': window.matchMedia('(max-width: 767px)').matches
        }
    };
};
